import { render, staticRenderFns } from "./CustomerReviews.vue?vue&type=template&id=bc7459c4&"
import script from "./CustomerReviews.vue?vue&type=script&lang=js&"
export * from "./CustomerReviews.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReviews.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VAvatar,VCarousel,VCarouselItem,VContainer,VResponsive})
